<template lang="">
  <div class="cardContent1">
    <div class="chart" ref="circleChart"></div>
  </div>
</template>

<script>
import { loadCircleChart } from "../chart/circleChart";
export default {
  data() {
    return {};
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.circleChart = this.$echarts.init(this.$refs.circleChart);

      // 各区种植面积占比
      const fontSizes = 13;
      const widths = 10;
      const itemGaps = 10;
      let circleData = [
        {
          name: "信宜市",
          value: 11.5
        },
        {
          name: "高州市",
          value: 55.6
        },
        {
          name: "化州市",
          value: 25.18
        },
        {
          name: "茂南区",
          value: 2.5
        },
        {
          name: "电白区",
          value: 36.1
        }
      ];
      loadCircleChart(
        this.circleChart,
        circleData,
        fontSizes,
        widths,
        itemGaps
      );

      window.addEventListener("resize", () => {
        this.circleChart.resize();
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.cardContent1
  height 100%
  .chart
    height 100%
</style>
